import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import InlineSearch from 'modules/core/components/InlineSearch'
import ScrollableList from 'modules/core/components/ScrollableList'
import useSearch from 'modules/core/hooks/useSearch'

import type { Automation } from 'modules/automations/store/models/Automation'
import type { ITriggerWithConditions } from 'modules/automations/store/models/Trigger'

import type { SelectedAction } from 'modules/automations/components/AddAutomationBlockModal/types'
import Items from './Items'

interface Props {
  automation: Automation
  trigger: ITriggerWithConditions
  selected: SelectedAction | null | undefined
  setSelected: (action: SelectedAction) => () => void
}

function List({ automation, trigger, selected, setSelected }: Props) {
  const { search, onSearch } = useSearch()

  return (
    <BoxList>
      <InlineSearch autofocus search={search} onSearch={onSearch} />
      <Box flexGrow background="grey100">
        <ScrollableList size="medium">
          <Items
            automation={automation}
            trigger={trigger}
            search={search}
            selected={selected}
            setSelected={setSelected}
          />
        </ScrollableList>
      </Box>
    </BoxList>
  )
}

export default observer(List)
